<template>
    <div class="sub-category-row">

        <button class="btn btn-primary" v-if="searchedCategory.subCategory">
            <font-awesome-icon icon="fa-solid fa-reply" @click="fastlineOrReturn" />
        </button>
        <div class="sub-category-list" ref="categoryList">
            <button class="btn" :class="{ active: category.active }" v-for="category in selectedCategories"
                @click="selectCategory(category)">
                {{ category.name }}
            </button>
        </div>

    </div>
</template>

<script>
export default {
    name: 'SubCategoryRow',
    components: {},
    data() {
        return {
            sub2present: true,
            subCategory: undefined,
            subSubCategory: undefined,
        }
    },
    computed: {
        searchedCategory() {
            return this.$store.getters.getSearchCategories
        },
        categories() {
            return this.$store.getters.getCategories
        },
        /* sub2Present(){
            let searched= this.searchedCategory
            let main = this.categories
                .find(category => category.name.localeCompare(searched.category, undefined, { sensitivity: 'base' }) === 0)

                if(searched.sub2Category){
                let sub = main.children
                    .find(category => category.name.localeCompare(searched.subCategory, undefined, { sensitivity: 'base' }) === 0)
            }
        }, */
        selectedCategories() {
            let searched = this.searchedCategory
            let result = []
            if (searched.subCategory) {
                let main = this.categories
                    .find(category => category.name.localeCompare(searched.category, undefined, { sensitivity: 'base' }) === 0)

                let sub = main.children
                    .find(category => category.name.localeCompare(searched.subCategory, undefined, { sensitivity: 'base' }) === 0)
                //if no sub2 found then display 
                let sub2present = sub.children.length > 0
                this.sub2present = sub2present
                result = sub2present
                    ? sub.children : main.children
            } else {
                let main = this.categories
                    .find(category => category.name.localeCompare(searched.category, undefined, { sensitivity: 'base' }) === 0)
                result = main.children
                this.sub2present = false;
            }
            let sub2Selected = searched.subCategory && searched.sub2Category

            return result
                .map(res => { res.active = false; return res })
                .sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                })
                .map(res => {
                    if (sub2Selected) {
                        if (res.name.localeCompare(searched.sub2Category) == 0) {
                            res.active = true
                        }
                    } else {
                        if (res.name.localeCompare(searched.subCategory) == 0) {
                            res.active = true
                        }
                    }
                    return res;
                })
        },
    }, methods: {
        fastlineOrReturn() {
            let search = this.searchedCategory
            let category = search.category
            let subCat = search.subCategory
            let sub2Cat = search.sub2Category
            if(search.subCategory && search.sub2Category){
                sub2Cat = ''
            }else if(search.subCategory){
                subCat=''
                sub2Cat=''
            }
            this.search({
                category: category,
                subCategory: subCat,
                sub2Category: sub2Cat,
            })
        },
        selectCategory(selected) {
            let search = this.searchedCategory
            let category = search.category
            let subCat = search.subCategory
            let sub2Cat = search.sub2Category
            if (!subCat && !sub2Cat) {
                subCat = selected.name
            } else if (subCat) {
                if (this.sub2present) {
                    sub2Cat = selected.name
                } else {
                    subCat = selected.name
                }
            }else{
                subCat = selected.name
            }
            // this.$store.dispatch('getFastLine')
            this.search({
                category: category,
                subCategory: subCat || '',
                sub2Category: sub2Cat || '',
            })
        },
        search(searchQuery){
            let row = this.$refs.categoryList
            if(row && searchQuery.sub2Category){
                row.scrollLeft=0
            }
            searchQuery.sub2present=this.sub2present
            this.$store.commit(`setSearchCategories`, searchQuery)
            this.$store.dispatch('searchStock', searchQuery)
        }
    }
}
</script>

<style lang="scss" scoped>
.category-tag {
    background: #fff;
    color: #252525;
    border: 1px solid #aaa;
    font-weight: 600;
    width: 150px !important;
    height: 60px
}

.btn {
    width: auto;
    background-color: #eee;
    border: 1px solid #aaa;
    color: #252525;
    text-wrap: nowrap;
    font-weight: 500;
    &:hover,
    &:focus {
        color: white;
        background: #252525;
    }

    &.active {
        color: white;
        background: #0092f7;
        font-weight: 700;
    }
}

.sub-category-row {
    display: flex;
    flex-direction: row;
    padding: 5px;

    .sub-category-list {
        width: auto;
        height: 100%;
        display: flex;
        flex-direction: row;
        gap: 10px;
        margin: 0 0 0 10px;
        padding: 5px 0 5px 10px;
        overflow-x: auto;
    }
}
</style>